import '../Home/Homepage.css';

import React from 'react';

import Feedposts from './Feedposts';

const Homepage = ({ posts, setPosts, setFriendsProfile, images }) => {

  console.log("Homepage", posts);
  return (
    <main className='homepage'>
      {/* {JSON.stringify(posts)} */}

      {posts && posts.length > 0 ? <Feedposts
        images={images}
        posts={posts}
        setPosts={setPosts}
        setFriendsProfile={setFriendsProfile}
      />
        :
        (<p style={{ textAlign: "center", marginTop: "40px" }}>
          NO POSTS ARE HERE
        </p>)
      }
    </main>
  )
}

export default Homepage